edit.classy.controller({
    name: 'ConvertModalController',
    inject: ['$scope', 'ApplicationService', 'EditApplicantsModalService', 'ApplicantModelService', 'ChildrenModelService', 'GradeSetupModelService', 
    		'$timeout', '$modalInstance', 'SchoolModelService', 'ModelService', 'EditSumsService', 'CalculationService'],
    init: function()
    {
        this.$.item = this.EditApplicantsModalService.getItem();
        this.$.index = this.EditApplicantsModalService.getIndex();
        this.$.grades = this.GradeSetupModelService.get();
        var temp = [];
        for (var j = 0; j < this.$.grades.length; j++)
            if (this.$.grades[j].del==0)
            	temp.push(this.$.grades[j]);
        this.$.grades = temp;
        if (this.$.item.applicantID!==undefined) 
        	this.$.type = 0;						//Applicant to Child
        else 
        	this.$.type = 1;						//Child to Applicant
        
        //BUILD PUT OBJECT
        if (this.$.type==0) {   //Build Child Object
        	this.$.putObject = this.ApplicationService.getFamilyData()['children'][this.ChildrenModelService.new()]
        	this.$.putObject.Chi_First_Name = this.$.putObject.xChi_First_Name = this.getField(this.$.item, 'App_First');
        	this.$.putObject.Chi_Last_Name = this.$.putObject.xChi_Last_Name = this.getField(this.$.item, 'App_Last');
        	this.$.putObject.Chi_DOB = this.$.putObject.xChi_DOB = this.getField(this.$.item, 'App_DOB');
        	this.$.putObject.Chi_Gender = this.$.putObject.xChi_Gender = this.getField(this.$.item, 'App_Gender');
        	this.$.putObject.Chi_Aid_Amt = this.$.putObject.xChi_Aid_Amt = this.$.item.ActAward;
        	if (this.$.putObject.Chi_Aid_Amt>0)
        		this.$.putObject.Chi_Aid = this.$.putObject.xChi_Aid = 1;
        	this.$.putObject.Chi_Present_School = this.$.putObject.xChi_Present_School = this.SchoolModelService.get()[0].School_Name;
        	this.$.putObject.Chi_Residence = this.$.putObject.xChi_Residence = 0;
        	this.$.putObject.Chi_Tuition_Amt = this.$.putObject.xChi_Tuition_Amt = this.getField(this.$.item, 'App_Tuition');
        	if (this.$.putObject.Chi_Tuition_Amt>0)
        		this.$.putObject.Chi_Tuition = this.$.putObject.xChi_Tuition = 1;

            var conversionArray = ['P', 'P', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'];
            this.$.putObject.Chi_Present_Grade = this.$.putObject.xChi_Present_Grade = conversionArray[parseInt(this.getField(this.$.item, 'App_Div_Code').substring(0,2))];
        }
        else if (this.$.type==1) {   //Build Applicant Object
        	this.$.putObject = this.ApplicationService.getAwardData()['applicants'][this.ApplicantModelService.new()]
        	this.$.putObject.App_First = this.$.putObject.xApp_First = this.getField(this.$.item, 'Chi_First_Name');
        	this.$.putObject.App_Last = this.$.putObject.xApp_Last = this.getField(this.$.item, 'Chi_Last_Name');
        	this.$.putObject.App_DOB = this.$.putObject.xApp_DOB = this.getField(this.$.item, 'Chi_DOB');
        	this.$.putObject.App_Gender = this.$.putObject.xApp_Gender = this.getField(this.$.item, 'Chi_Gender');
        	this.$.putObject.ActAward = this.getField(this.$.item, 'Chi_Aid_Amt');
        	this.$.putObject.App_Tuition = this.getField(this.$.item, 'Chi_Tuition_Amt');
        	this.$.putObject.App_529 = this.$.putObject.xApp_529 = '';
        	this.$.putObject.App_Div_Code = this.$.putObject.xApp_Div_Code = '';
        	this.$.putObject.App_Division = this.$.putObject.xApp_Division = '';
        	this.$.putObject.App_Middle = this.$.putObject.xApp_Middle = '';
        	this.$.putObject.App_SS_Inc = this.$.putObject.xApp_SS_Inc = '';
        	this.$.putObject.App_Trust_Val = this.$.putObject.xApp_Trust_Val = '';
        	this.$.putObject.App_Trust_Desc = this.$.putObject.xApp_Trust_Desc = '';
        }

        if (this.$.putObject.xApp_DOB!==undefined) {
            this.$.xApp_DOB = this.$.putObject.xApp_DOB.toString();
        }
        if (this.$.putObject.xChi_DOB!==undefined) {
            this.$.xChi_DOB = this.$.putObject.xChi_DOB.toString();
        }

    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    gradefill: function()
    {
        for (var i = 0; i < this.$.grades.length; i++) {
            if (this.$.putObject.xApp_Div_Code == this.$.grades[i].DivisionCode) {
                this.$.putObject.xApp_Division = this.$.grades[i].divisionDesc;
                this.$.putObject.App_Tuition = this.$.grades[i].tuition;
            }
        }
    },
    startSaveApplicant: function(scope, instance, form)
    {
        //Filling in Data
        //if (this.$.grades[i].tuition==0) this.gradefill();

        instance.options.factor  = .3;
        var parent = this;
        if (form.$valid && this.SchoolModelService.get()[0].Anonymous==0) 
        {
            if (this.$.putObject.recordID==undefined) { //insert new record
                //copy edit fields to original fields for backwards compatibility with v3.
                this.$.putObject['App_First'] = this.$.putObject['xApp_First'];
                this.$.putObject['App_Last'] = this.$.putObject['xApp_Last'];
                this.$.putObject['App_Middle'] = this.$.putObject['xApp_Middle'];
                this.$.putObject['App_Gender'] = this.$.putObject['xApp_Gender'];
                this.$.putObject['App_DOB'] = this.$.putObject['xApp_DOB'];
                this.$.putObject['App_Division'] = this.$.putObject['xApp_Division'];
                this.$.putObject['App_Div_Code'] = this.$.putObject['xApp_Div_Code'];
                this.$.putObject['App_Trust_Val'] = this.$.putObject['xApp_Trust_Val'];
                this.$.putObject['App_Trust_Desc'] = this.$.putObject['xApp_Trust_Desc'];
                this.$.putObject['App_SS_Inc'] = this.$.putObject['xApp_SS_Inc'];
                this.$.putObject['App_529'] = this.$.putObject['xApp_529'];
                this.$.putObject['added'] = 1;
                this.ApplicantModelService.post(this.$.putObject.applicationID, this.$.putObject, instance).then(function (response) {
                    parent.$.putObject.recordID = response.data.id;
                    //parent.ApplicationService.getAwardData()['applicants'].push(parent.$.putObject);

                    parent.livingAllowancePut(1); 

                });
            }

            var AppTotal = 0;
            for (var i = 0; i < this.ApplicationService.getAwardData()['applicants'].length; i++) {
                AppTotal += parseInt(this.ApplicationService.getAwardData()['applicants'][i].App_Tuition);
            }
            var editsumsobject = {'applicationID': this.ApplicationService.getAwardData().app[0].applicationID, 'familyID': this.ApplicationService.getFamilyData().data[0].familyID, 'Applicant_Total': AppTotal};
            this.EditSumsService.put(editsumsobject).then(function (response) {
                parent.ApplicationService.getAwardData().family[0].edit_sums.Applicant_Total = AppTotal;
                parent.ApplicationService.getAwardData().tuition = AppTotal;
                //parent.$.$apply();
            });
        }
        else
        {
            instance.stop(-1); 
        }
    },
    startSaveChild: function(scope, instance, form)
    {
        if (form.$valid)
        {
            instance.options.factor = .5;

            this.ApplicationService.getAwardData().tuition -= this.$.item.App_Tuition;
            this.ChildrenModelService.post(this.ApplicationService.getFamilyData().data[0].familyID, this.$.putObject, instance)
            this.livingAllowancePut(1);
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, callback)
    {
        //this.$.models[type].updateData();
        if (typeof callback != 'undefined')
            callback();
        if (this.$.type==0) { //Remove Applicant
            this.ApplicationService.getAwardData().applicants[this.$.index].del = 1;
        	this.ApplicantModelService.purge(this.ApplicationService.getAwardData().applicants[this.$.index].recordID, this.ApplicationService.getAwardData().applicants[this.$.index], instance);
        	this.ApplicationService.getAwardData().applicants.splice(this.$.index, 1);
        }
        else {				  //Remove Child
        	this.ChildrenModelService.purge(this.ApplicationService.getFamilyData().data[0].familyID, this.ApplicationService.getFamilyData().children[this.$.index], instance);
        	this.ApplicationService.getFamilyData().children.splice(this.$.index, 1);
        }
        this.$modalInstance.dismiss('cancel');
    },
    livingAllowancePut: function(number)
    {
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};

        putDataThresh.Thresh_Living_Allowance = dataThresh.Thresh_Living_Allowance;
        putDataThresh.Thresh_Allow_Per_Child = dataThresh.Thresh_Allow_Per_Child;

        if(this.$.type) //Child to Applicant
        {
            putDataEditSums.Applicant_Count = parseInt(dataEditSums.Applicant_Count)+number;
            putDataEditSums.Child_Count = parseInt(dataEditSums.Child_Count)-number;
        }else //Applicant to Child
        {
            putDataEditSums.Child_Count = parseInt(dataEditSums.Child_Count)+number;
            putDataEditSums.Applicant_Count = parseInt(dataEditSums.Applicant_Count)-number;
        }

        this.ModelService.FamilyThreshEditSumsService
            .putHelper(dataThresh, dataEditSums, putDataThresh, putDataEditSums)
            .then(() => {
                this.CalculationService.reCalc();
            });
    },
    dismiss: function(t)
    {
    	if (t==0) {
    		this.ApplicationService.getFamilyData()['children'].pop();
    	}
    	else {
    		this.ApplicationService.getAwardData()['applicants'].pop();
    	}

    	this.$modalInstance.dismiss('cancel');
    }
});
